import { useTranslation } from "react-i18next";

import { TruncatedTextTooltip } from "src/core/components/custom-ui/truncated-text-tooltip";
import { Checkbox } from "src/core/components/ui/checkbox";
import { Status } from "src/core/constants/folders";
import { useFolder } from "src/core/contexts/FolderContext";
import { cn } from "src/core/lib/utils";

export const FolderDiligencesReadOnly = ({ folderState }: { folderState: Status }) => {
  const { t } = useTranslation();
  const { folderFile } = useFolder();
  const selectedDiligences = folderFile.folderFile?.diligences.filter(
    (diligence) => diligence.selected
  );
  const unselectedDiligences = folderFile.folderFile?.diligences.filter(
    (diligence) => !diligence.selected
  );
  const hasSelected = selectedDiligences && selectedDiligences.length > 0;
  const hasUnselected = unselectedDiligences && unselectedDiligences.length > 0;

  const isValidationState =
    folderState === Status.VALIDATION_PENDING || folderState === Status.VALIDATION_PENDING_HR;
  const isFinalState = folderState === Status.VALIDATED || folderState === Status.REJECTED;

  if (folderFile.folderFile?.diligences.length === 0) {
    return (
      <div className="text-base font-light text-muted-foreground ml-30">
        {t("folder.diligences.noTriggered")}
      </div>
    );
  }
  // Cas VALIDATED ou REJECTED : afficher uniquement les sélectionnées
  if (isFinalState && !hasSelected) {
    return (
      <div className="text-base font-light text-muted-foreground ml-30">
        {t("folder.diligences.noDiligenceSelected")}
      </div>
    );
  }

  // Cas VALIDATION_PENDING ou VALIDATION_PENDING_HR : afficher les deux listes
  if (isValidationState && !hasSelected && !hasUnselected) {
    return (
      <div className="text-base font-light text-muted-foreground ml-30">
        {t("folder.diligences.noDiligences")}
      </div>
    );
  }

  return (
    <div>
      <ul className="folder-diligences-data-one-page">
        {hasSelected && (
          <>
            <li className="folder-diligences-data-item folder-diligences-data-item-section rounded-t-lg">
              <span>{t("folder.diligences.selectedDiligences")}</span>
            </li>
            {selectedDiligences.map((diligence) => (
              <li key={diligence.id} className="folder-diligences-data-item-read-only">
                <Checkbox
                  className="text-blue-primary border-blue-primary"
                  checked={Boolean(diligence.selected)}
                  disabled={true}
                />
                <TruncatedTextTooltip>{diligence.name}</TruncatedTextTooltip>
              </li>
            ))}
          </>
        )}
        {hasUnselected && isValidationState && (
          <>
            <li
              className={cn(
                "folder-diligences-data-item folder-diligences-data-item-section border-b border-border",
                !hasSelected ? "rounded-t-lg" : "border-t border-border"
              )}
            >
              <span>{t("folder.diligences.unselectedDiligences")}</span>
            </li>
            {unselectedDiligences.map((diligence) => (
              <li
                key={diligence.id}
                className="folder-diligences-data-item-read-only text-muted-foreground line-through"
              >
                <Checkbox
                  className="text-blue-primary border-foreground bg-muted"
                  checked={Boolean(diligence.selected)}
                  disabled={true}
                />
                <TruncatedTextTooltip>{diligence.name}</TruncatedTextTooltip>
              </li>
            ))}
          </>
        )}
      </ul>
    </div>
  );
};
